import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  QaiButtonComponent,
  QaiDialogComponent,
  QaiIconComponent,
} from '@qai/ui';
import { EntityType } from 'src/app/utils/enums/self-serve/assignment-type.enum';

@Component({
  selector: 'delete-modal',
  standalone: true,
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    QaiDialogComponent,
    QaiButtonComponent,
    QaiIconComponent,
  ],
})
export class DeleteModalComponent implements OnChanges {
  @ViewChild('deleteDialog') dialogRef: QaiDialogComponent | undefined;

  @Input() type: EntityType = EntityType.SIMULATION;
  @Input() open: boolean = false;
  @Input() networkRequestInProgress: boolean = false;
  @Input() assignmentStatus?: string;
  @Input() moduleUuid?: string;

  @Output() openChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  heading = '';
  content = '';
  deleteLabel = '';
  isDeleteDisabled = false;

  private readonly labelsMap: Record<
    EntityType,
    {
      heading: string;
      content: string;
      deleteLabel: string;
      isDeleteDisabled: boolean;
    }
  > = {
    [EntityType.SIMULATION]: {
      heading: 'Delete simulation',
      content:
        'This simulation will be deleted. Any test assignments associated with the simulation will be removed as well.',
      deleteLabel: 'Delete simulation',
      isDeleteDisabled: false,
    },
    [EntityType.ASSIGNMENT]: {
      heading: 'Delete assignment',
      content: 'This assignment will be deleted permanently.',
      deleteLabel: 'Delete assignment',
      isDeleteDisabled: false,
    },
    [EntityType.NON_STAGED_ASSIGNMENT]: {
      heading: 'Delete assignment',
      content:
        'To delete an assignment with Active, or Completed status, please contact the CX team. Thank you.',
      deleteLabel: 'Delete assignment',
      isDeleteDisabled: true,
    },
  };

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnChanges(): void {
    const normalizedStatus = this.assignmentStatus?.toLowerCase() || '';
    const isDeletableStatus = normalizedStatus === 'staged' || normalizedStatus === 'draft';
    const labelKey =
      this.type === EntityType.ASSIGNMENT && !isDeletableStatus
        ? EntityType.NON_STAGED_ASSIGNMENT
        : this.type;

    const labels = this.labelsMap[labelKey];
    this.heading = labels.heading;
    this.content = labels.content;
    this.deleteLabel = labels.deleteLabel;
    this.isDeleteDisabled = labels.isDeleteDisabled;

    this.updateModalState();
  }

  handleDelete(): void {
    this.confirm.emit();
  }

  handleClose(): void {
    this.setClosedState();
  }

  private updateModalState(): void {
    if (this.open) {
      this.dialogRef?.showModal();
    } else {
      this.dialogRef?.close();
    }
  }

  private setClosedState(): void {
    if (this.open) {
      this.closeModal.emit();
      this.open = false;
      this.dialogRef?.close();
      this.openChange.emit(false);
      this.cdRef.detectChanges();
    }
  }
}
